import { components } from 'be-types';
import { DataScope } from './global-enum';
import { ApiRequestParams } from './global-interfaces';
import { RoleCreateProfileCred } from 'src/services/role.service';

export const rolesTableApiRequestParams: ApiRequestParams = {
  dataScope: DataScope.RoleTable,
  locationID: 0,
};

export type ProfileResource = components['schemas']['ProfileResource'];
export type AssignRoleRequest = components['schemas']['StoreSecurityRequest'];
export type SingleProfileData = components['schemas']['ShowProfileResource'];
export type SingleProfileDataProfileCred = components['schemas']['ProfileCredResource'];
export type CredResource = components['schemas']['CredsResource'];
export type RoleResource = components['schemas']['ShowUserRoleResource'];

export interface ProfileSummary {
  id: number;
  profileDescription: string;
  locationID?: number;
  profileID: number;
  selected?: boolean;
  completeSelected?: boolean;
  users?: number[];
}

export interface ProfileCred {
  profileID: number;
  cred: CredResource;
}

export interface CreateRoleRequest {
  profileDescription: string;
  credsArray: RoleCreateProfileCred[];
  locationID?: number;
}

export enum RolePrivileges {
  None = 0,
  Have = 1,
}
